<template>
  <div class="container">
    <div class="module-title">广告内容</div>
    <div v-for="(item, index) in adDetails" :key="index">
      <div class="first-part">
        <van-cell
          v-if="index === 0"
          title="门店类型"
          :value="item.dealerType === 1 ? '汽修厂' : '专卖店'"
        />
        <van-cell
          v-if="index === 0"
          title="品牌类型"
          :value="apply.productBrand | productBrand"
        />
        <van-cell v-if="index === 0" title="广告类型" value="门头招牌" />
        <van-cell
          title="材质"
          :value="item.materialQuality | materialQuality"
        />
        <div class="example-img">
          <div>版面示例</div>
          <van-image :src="item.pageExample" @click="previewImg">
            <template v-slot:error>加载失败</template>
          </van-image>
        </div>
        <div class="example-img">
          <div>效果图</div>
          <van-image :src="$imgPath + item.thumbnail" @click="previewImg">
            <template v-slot:error>加载失败</template>
          </van-image>
        </div>
      </div>
      <div class="second-part">
        <van-cell title="广告长度" :value="item.longs + '米'" />
        <van-cell title="广告长度" :value="item.height + '米'" />
        <van-cell
          title="广告内容"
          :value="item.content.trim() === '' ? '无内容' : item.content"
        />
        <van-cell
          title="实景图片"
          :value="item.realSceneImg.length === 0 ? '无上传照片' : ''"
        />
        <van-image
          v-for="(img, indexes) in item.realSceneImg"
          :key="indexes"
          width="100"
          height="100"
          :src="$imgPath + img"
          @click="previewImg"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      apply: {},
      adDetails: []
    };
  },
  filters: {
    productBrand(type) {
      switch (type) {
        case 1:
          return "原动力";
        case 2:
          return "力猛";
        case 3:
          return "原动力+力猛";
        default:
          break;
      }
    },
    materialQuality(type) {
      switch (type) {
        case 1:
          return "铁架+灯布";
        case 2:
          return "彩钢板+PVC";
        case 3:
          return "铝塑板+PVC字";
        case 4:
          return "铝塑板+平面发光字";
        case 5:
          return "纯灯布";
        default:
          break;
      }
    }
  },
  created() {
    this.getDetail(this.$route.query.id);
  },
  methods: {
    //广告详情
    getDetail(id) {
      this.$api.adDetails(id).then(res => {
        // console.log("res: ", res);
        res = res.result;
        this.apply = res.apply;
        this.adDetails = res.contents;
        this.adDetails.forEach(val => {
          if (val.realSceneImg.length != 0) {
            val.realSceneImg = val.realSceneImg.split(",");
          } else {
            val.realSceneImg = [];
          }
        });
      });
    },
    //预览图片
    previewImg(e) {
      ImagePreview([e.srcElement.src]);
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .module-title {
    padding: 5px 0;
    background-color: #eaeaea;
  }

  .first-part {
    border-bottom: 15px solid #eaeaea;

    .example-img {
      display: flex;
      align-items: center;
      padding: 10px 16px;
      font-size: 14px;

      div {
        flex: 1;
        text-align: left;
      }

      van-image {
        flex: 1;
      }
    }

    .van-cell__title {
      text-align: left;
    }

    .van-cell__value {
      text-align: center;
    }
  }

  .second-part {
    border-bottom: 15px solid #eaeaea;

    .van-cell__title {
      text-align: left;
    }

    .van-cell__value {
      text-align: center;
    }
  }

  .van-field {
    margin-bottom: 20px;
  }
}
</style>
